import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-thank-you-verify-email",
  templateUrl: "./thank-you-verify-email.component.html",
  styleUrls: ["./thank-you-verify-email.component.scss"],
  standalone: false,
})
export class ThankYouVerifyEmailComponent {
  constructor(private router: Router) {
    const nav = this.router.currentNavigation();
    // Only allow navigation if coming from ThankYouCreateAccountComponent
    if (!nav || !nav.extras.state || !nav.extras.state.fromCreateAccount) {
      this.router.navigate(["/"]);
    }
  }

  goToDrLanding() {
    this.router.navigate(["/dr-request"]);
  }
}
